import { render } from "./Toggle.vue?vue&type=template&id=52c4e3d7"
import script from "./Toggle.vue?vue&type=script&lang=js"
export * from "./Toggle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/Toggle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52c4e3d7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52c4e3d7', __exports__)) {
    api.reload('52c4e3d7', __exports__)
  }
  
  module.hot.accept("./Toggle.vue?vue&type=template&id=52c4e3d7", () => {
    api.rerender('52c4e3d7', render)
  })

}


export default __exports__